export default __webpack_public_path__ + "static/media/uploader-oneTouchVerio-3.07707e10.png";